module.exports = __webpack_public_path__ + "images/icon/download_12-8bc9aa6b.svg";